import enLocale from 'element-ui/lib/locale/lang/en'

const en = {
  app_name:'IDMIC Judging System',
  account:'Login Account',
  inputaccount:'Please enter your account',
  inputpassword:'Please enter your password',
  toLogin:'Log in',
  accountNotEmpty:'Account cannot be empty',
  passwordNotEmpty:'Password cannot be empty',
  niandushenhe:'Annual Submission Judging',
  firstReview:'Preliminary Judging',
  secondReview:'Semi-finals Judging ',
  firstReviewUnstart:'The Preliminary Judging HAS NOT YET Begun',
  firstReviewing:'Preliminary Judging in progress',
  firstReviewEnd:'Preliminary Judging completed',
  firstReviewTime:'Preliminary Judging period: ',
  groupNum:'Group ID',
  wordCount:'Number of submissions',
  reviewProcess:'Judging progress',
  startReview:'Start Review',
  continueReview:'Continue Review',
  seeDetail:'View Details',
  secondReviewUnstart:'The Semi-finals Judging HAS NOT YET Begun',
  secondReviewing:'Semi-finals Judging in progress',
  secondReviewEnd:'Semi-finals Judging completed',
  secondReviewTime:'Semi-finals Judging period:',
  home:'Home',
  unReview:'Unreviewed',
  unSubmit:'To be Submitted',
  isSubmit:'Submitted',
  tongguolv:'Current Pass Rate: ',
  workName:'Title',
  type:'Category',
  file:'File',
  result:'Judging Result',
  tongguo:'Pass',
  weitongguo:'Failed',
  pingyu:'Comments',
  lev:'Grade',
  op:'Operation',
  edit:'Edit Review',
  toPingshen:'Review',
  detail:'View Details',
  report:'Production Report',
  toScore:'Score',
  score:'Score: ',
  inputScore:'Please enter a score (out of 100)',
  istongguo:'Status: ',
  reviewLev:'Grade: ',
  inputPingyu:'Please enter comments',
  cancel:'Cancel',
  cancel2:'Cancel',
  yes:'Complete',
  workDetail:'Submission Details',
  baseInfo:'Basic Information',
  author:'Author',
  tel:'Phone',
  mail:'Email',
  cardType:'ID Type',
  cardCode:'ID Number',
  panlink:'Cloud Storage Link (URL)',
  workintro:'Abstract',
  workFile:'Project File',
  loading:'Loading...',
  empty:'No data',
  submitConfirm:'Once submitted, no changes can be made. Confirm submission?',
  exit:'Log Out',
  langBtn:'中文',


  //elementUI
  ...enLocale
}
export default en
